export default "__VITE_ASSET__BGvLWpJa__"